import React from "react";
import { FluidViewer } from "@wuilt/fluid-engine/build/FluidViewer";
import useElements from "../hooks/useElements";
const FluidElement = ({
  value,
  pageContext
}) => {
  const wuiltContext = useElements();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FluidViewer, {
    data: value,
    pageContext: pageContext,
    wuiltContext: wuiltContext
  }));
};
export default FluidElement;
//# sourceMappingURL=FluidElement.js.map